import { useEffect, useState } from 'react';

/**
 * Subscribes to a media query from React.
 *
 * CSS can restyle, hide and move things on a narrow screen, but it cannot
 * *regroup* them — and that is what a row of controls has to do when there is
 * no longer room for it: become a menu. Deciding that in JS keeps one set of
 * controls in the tree instead of two competing ones fighting over
 * `display: none`, so the breakpoint has to be readable here too. Keep the
 * queries passed in aligned with the breakpoints in the stylesheets.
 */
export function useMediaQuery(query: string): boolean {
  const [matches, setMatches] = useState(() => window.matchMedia(query).matches);

  useEffect(() => {
    const list = window.matchMedia(query);
    const sync = () => setMatches(list.matches);
    // Re-read on subscribe: the viewport can have changed between the initial
    // render and this effect, and between a query change and its listener.
    sync();
    list.addEventListener('change', sync);
    return () => list.removeEventListener('change', sync);
  }, [query]);

  return matches;
}
